import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllAcademics = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAcademics}?CompanyCode=${companyCode}`
  );
  return data;
};

const getAcademicById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.AcademicAPI}?isAll=false&code=${code}`
  );
  return data;
};

const insertAcademic = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.AcademicAPI, input);
  return data;
};

const updateAcademic = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.AcademicAPI, input);
  return data;
};

const deleteAcademic = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.AcademicAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetAcademicsQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAcademics],
    queryFn: () => getAllAcademics(companyCode),
  });
};

export const useGetAcademicByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.AcademicAPI],
    queryFn: () => getAcademicById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertAcademicMutation = () => {
  return useMutation({
    mutationFn: insertAcademic,
  });
};

export const useUpdateAcademicMutation = () => {
  return useMutation({
    mutationFn: updateAcademic,
  });
};

export const useDeleteAcademicMutation = () => {
  return useMutation({
    mutationFn: deleteAcademic,
  });
};
